/* istanbul ignore file */
import { BaseStore } from '../../../types';
import { postFilterProposalsBySummary } from '../Proposals';
import { ProposalSummaryRequestBody, ProposalSummaryResponseBody } from '../types';

type CallbackFunction = () => void;

const DEFAULT_SNAPSHOT: ProposalSummaryResponseBody = {
  proposalSummaries: [],
  resultsFound: 0,
};

interface StoreResponse<S, R> extends BaseStore<R> {
  fetchAndUpdateSnapshot: (proposalSummaryRequestBody: S) => void;
}

export class FilterProposalsBySummaryStore {
  private static snapshotMap: Record<string, ProposalSummaryResponseBody> = {};
  private static subscribersMap: Record<string, Set<CallbackFunction>> = {};

  private constructor() {
    // noop
  }

  private static _getSubscribers = (snapshotKey: string): Set<CallbackFunction> => {
    if (FilterProposalsBySummaryStore.subscribersMap[snapshotKey] === undefined) {
      FilterProposalsBySummaryStore.subscribersMap[snapshotKey] = new Set();
    }

    return FilterProposalsBySummaryStore.subscribersMap[snapshotKey];
  };

  static getStore(snapshotKey: string): StoreResponse<ProposalSummaryRequestBody, ProposalSummaryResponseBody> {
    return {
      getSnapshot: () => {
        if (FilterProposalsBySummaryStore.snapshotMap[snapshotKey] === undefined) {
          FilterProposalsBySummaryStore.snapshotMap[snapshotKey] = DEFAULT_SNAPSHOT;
        }

        return FilterProposalsBySummaryStore.snapshotMap[snapshotKey];
      },
      subscribe: (callback: CallbackFunction) => {
        FilterProposalsBySummaryStore._getSubscribers(snapshotKey).add(callback);
        return () => FilterProposalsBySummaryStore._getSubscribers(snapshotKey).delete(callback);
      },
      fetchAndUpdateSnapshot(proposalSummaryRequestBody: ProposalSummaryRequestBody) {
        postFilterProposalsBySummary(proposalSummaryRequestBody)
          .then((response) => {
            FilterProposalsBySummaryStore.snapshotMap[snapshotKey] = response.data;
            FilterProposalsBySummaryStore._getSubscribers(snapshotKey).forEach((callback) => {
              callback();
            });
          })
          .catch((e) => {
            console.error(`Polling failure for ${snapshotKey}: ${e}`);
          });
      },
    };
  }
}
